import styled from 'styled-components'
import { theme } from '../../../../../styles/theme'

export const Container = styled.div`
  width: 100%;
`

export const FormWrapper = styled.div`
  height: 100%;
  width: 100%;
  margin: 90px 0px 60px;
  padding: 0px 40px;

  background: ${theme.colors.mainBg};
`
